import { lazy } from 'react'

export const SubscriptionsVariant5 = lazy(
  () => import('./SubscriptionsVariant5'),
)
